import { useState, useReducer, useEffect, useRef } from "react";
import axios from "axios";
import { serverHost } from "../../../http_common.js"; 
import { countriesOnEarth } from "./registrationStatesAndLGA.js";
import { useFlutterwave, closePaymentModal } from "flutterwave-react-v3";
import { useSelector } from "react-redux";
import { industriesCategoriesData } from "../../../industriesCategoriesData";
import { useSnackbar } from "notistack";
import { useDispatch } from "react-redux";
import AlertBar from "../../../AlertBar.jsx";
import * as Yup from "yup";
import { useFormik } from "formik";
import * as Action from "../../../store/redux/registrationReducer.js";
import "./registration.rwd.css";
import "./registration.css";
import IsLoading from "../../../IsLoading";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { statesAndLgas } from "./registrationStatesAndLGA.js";

// imported icon
import QrCode2Icon from "@mui/icons-material/QrCode2";
import IosShareIcon from "@mui/icons-material/IosShare";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import SellOutlinedIcon from "@mui/icons-material/SellOutlined";
import GroupAddOutlinedIcon from "@mui/icons-material/GroupAddOutlined";
import AddLocationAltOutlinedIcon from "@mui/icons-material/AddLocationAltOutlined";
import BrandingWatermarkOutlinedIcon from "@mui/icons-material/BrandingWatermarkOutlined";
import StreamOutlinedIcon from "@mui/icons-material/StreamOutlined";
import RemoveIcon from "@mui/icons-material/Remove";

import Person2Icon from "@mui/icons-material/Person2";
import Face4Icon from "@mui/icons-material/Face4";
import DashboardRoundedIcon from "@mui/icons-material/DashboardRounded";
import AssignmentRoundedIcon from "@mui/icons-material/AssignmentRounded";
import PeopleAltRoundedIcon from "@mui/icons-material/PeopleAltRounded";
import CategoryRoundedIcon from "@mui/icons-material/CategoryRounded";
import SchoolIcon from "@mui/icons-material/School";

let newClient, companyPlans, companyFeatures, companyPermissions, companyRoles;

export default function Registration() {
  const wrapperRef = useRef(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const referralCodeFromURL = searchParams.get("ref") || "";
  // URL is the source of truth
  const plan = searchParams.get("plan") || "premium";
  const planIndex = searchParams.get("index") || 2;

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const navigateTo = useNavigate();
  const dispatch = useDispatch();
  const [selectedCurrency, setSelectedCurrency] = useState([]);
  const [billingCycle, setBillingCycle] = useState("MONTHLY");
  const [doesExist, setDoesExist] = useState();
  const [alert, setAlert] = useState(null);
  const [countryCode, setcountryCode] = useState("+234 - Nigeria");
  const [opencountryCodes, setOpencountryCodes] = useState(false);
  const [openGender, setOpenGender] = useState(false);

  const [filteredCountries, setFilteredCountries] = useState([]);
  const [searchTermCountries, setSearchTermCountries] = useState("");
  const handleSearchCountries = (e) => {
    const term = e.target.value;
    setSearchTermCountries(term);

    if (term.trim() === "") {
      setFilteredCountries([]);
    } else {
      const filtered = countriesOnEarth.filter((countries) =>
        countries?.country.toLowerCase().includes(term.toLowerCase()),
      );
      setFilteredCountries(filtered);
    }
  };
  // ****************************** GENERATING APPLICATION NUMBER FOR APPLICANTS **************************************

  // FUNTIONS FOR THE STATE SELECTIONS
  const [selectedState, setSelectedState] = useState("");
  const [localGovernments, setLocalGovernments] = useState([]);

  const handleStateChange = (e) => {
    const state = e.target.value;
    setSelectedState(state);
    setRegistrationData({ state_of_address: e.target.value });
    setLocalGovernments(statesAndLgas[state] || []);
  };
  // ------------------------
  const [loading, setLoading] = useState(false);
  const [registrationData, setRegistrationData] = useReducer(
    (request, response) => {
      return { ...request, ...response };
    },
    {
      firstName: "",
      surName: "",
      otherName: "",
      email: "",
      phone: "",
      password: "",
      gender: "",
      business_Category: "",
      industryItem: "",
      industryId: "",
      nationality: "Nigeria",
      international_dialing_code: "+234",
      businessName: "",
      description: "",
      businessPhoneNo1: "",
      businessPhoneNo2: "",
      // None Registration  Database Content
      flag: "https://flagcdn.com/w40/ng.png",
      termsOfService: false,
      // Referral code from shared URL
      referralCode: referralCodeFromURL,
    },
  );

  const actions = useSelector((state) => state.applictaionForm);

  // PLAN SECTION FOR CLIENT REGISTRATION
  const plans = [
    {
      name: "Standard",
      serviceId: "srv-d6sln7paae7s73ddqh10",
      priceYearly: 46386.0,
      priceMonthly: 3865.5,
      actualPrice: 12650,
      currency: "NGN",
      discount: "Save 12%",
      discountPercent: 12,
      class: "standard",
      actionBtn: "Get Started",
      features: [
        {
          discription: "Real time Point of sales",
          logo: <StreamOutlinedIcon fontSize="large" />,
        },
        {
          discription: "40 barcode label creation",
          logo: <BrandingWatermarkOutlinedIcon fontSize="large" />,
        },
        {
          discription: "40 qrcode label creation",
          logo: <QrCode2Icon fontSize="large" />,
        },
        {
          discription: "export excel",
          logo: <IosShareIcon fontSize="large" />,
        },
        {
          discription: "export pdf",
          logo: <PictureAsPdfOutlinedIcon fontSize="large" />,
        },
        {
          discription: "export csv",
          logo: <QrCode2Icon fontSize="large" />,
        },
        {
          discription: "100 unique items",
          logo: <SellOutlinedIcon fontSize="large" />,
        },
        {
          discription: "1 user",
          logo: <GroupAddOutlinedIcon fontSize="large" />,
        },
        {
          discription: "3 location +",
          logo: <AddLocationAltOutlinedIcon fontSize="large" />,
        },
      ],
      footer: "",
    },
    {
      name: "Professional",
      serviceId: "srv-d6sln7paae7s73ddqh10",
      priceYearly: 71411.28,
      priceMonthly: 5950.94,
      actualPrice: 18500.0,
      currency: "NGN",
      discount: "Save 20%",
      discountPercent: 20,
      class: "professional",
      tag: "Most Popular",
      actionBtn: "Start Professionally",
      features: [
        {
          discription: "Real time Point of sales",
          logo: <StreamOutlinedIcon fontSize="large" />,
        },
        {
          discription: "40 barcode label creation",
          logo: <BrandingWatermarkOutlinedIcon fontSize="large" />,
        },
        {
          discription: "40 qrcode label creation",
          logo: <QrCode2Icon fontSize="large" />,
        },
        {
          discription: "export excel",
          logo: <IosShareIcon fontSize="large" />,
        },
        {
          discription: "export pdf",
          logo: <PictureAsPdfOutlinedIcon fontSize="large" />,
        },
        {
          discription: "export csv",
          logo: <QrCode2Icon fontSize="large" />,
        },
        {
          discription: "500 unique items",
          logo: <SellOutlinedIcon fontSize="large" />,
        },
        {
          discription: "4 users",
          logo: <GroupAddOutlinedIcon fontSize="large" />,
        },
        {
          discription: "2 location +",
          logo: <AddLocationAltOutlinedIcon fontSize="large" />,
        },
      ],
      footer:
        "Ideal for growing businesses that require advanced inventory management, multi-user access, and enhanced reporting features to streamline operations and support expansion.",
    },
    {
      name: "Premium",
      serviceId: "srv-d6sln7paae7s73ddqh10",
      priceYearly: 198000.0,
      priceMonthly: 16500.0,
      actualPrice: 49500.0,
      currency: "NGN",
      discount: "Save 25%",
      discountPercent: 25,
      class: "premium",
      actionBtn: "Go Premium",
      features: [
        {
          discription: "Real time Point of sales",
          logo: <StreamOutlinedIcon fontSize="large" />,
        },
        {
          discription: "40 barcode label creation",
          logo: <BrandingWatermarkOutlinedIcon fontSize="large" />,
        },
        {
          discription: "40 qrcode label creation",
          logo: <QrCode2Icon fontSize="large" />,
        },
        {
          discription: "export excel",
          logo: <IosShareIcon fontSize="large" />,
        },
        {
          discription: "export pdf",
          logo: <PictureAsPdfOutlinedIcon fontSize="large" />,
        },
        {
          discription: "export csv",
          logo: <QrCode2Icon fontSize="large" />,
        },
        {
          discription: "2,000 unique items",
          logo: <SellOutlinedIcon fontSize="large" />,
        },
        {
          discription: "12 users",
          logo: <GroupAddOutlinedIcon fontSize="large" />,
        },
      ],
      footer:
        "Built for established businesses that require powerful inventory control, team collaboration, detailed reporting, and scalable operations for higher sales volume.",
    },
    {
      name: "Enterprise",
      serviceId: "srv-d6sln7paae7s73ddqh10",
      price: "",
      priceYearly: 310200.0,
      priceMonthly: 25850.0,
      actualPrice: 77550.0,
      currency: "NGN",
      discount: "Save 31%",
      discountPercent: 31,
      class: "enterprise",
      tag: "Advance",
      actionBtn: "Unlock Full Access",
      features: [
        {
          discription: "Real time Point of sales",
          logo: <StreamOutlinedIcon fontSize="large" />,
        },
        {
          discription: "40 barcode label creation",
          logo: <BrandingWatermarkOutlinedIcon fontSize="large" />,
        },
        {
          discription: "40 qrcode label creation",
          logo: <QrCode2Icon fontSize="large" />,
        },
        {
          discription: "export excel",
          logo: <IosShareIcon fontSize="large" />,
        },
        {
          discription: "export pdf",
          logo: <PictureAsPdfOutlinedIcon fontSize="large" />,
        },
        {
          discription: "export csv",
          logo: <QrCode2Icon fontSize="large" />,
        },
        {
          discription: "15,000 unique items",
          logo: <SellOutlinedIcon fontSize="large" />,
        },
        {
          discription: "45 users +",
          logo: <GroupAddOutlinedIcon fontSize="large" />,
        },
        {
          discription: "4 location +",
          logo: <AddLocationAltOutlinedIcon fontSize="large" />,
        },
      ],
      footer:
        "Best for large businesses and multi-location companies that need enterprise-grade performance, massive inventory management, advanced reporting, and support for large teams.",
    },
  ];

  const registrationDate = new Date();

  const startDate = new Date(registrationDate);
  const expiryDate = new Date(registrationDate);

  if (billingCycle === "MONTHLY") {
    expiryDate.setMonth(expiryDate.getMonth() + 1);
  } else if (billingCycle === "YEARLY") {
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
  }

  console.log("PLAN ID", companyPlans?.[planIndex]?.planId);
  
  const subscription = {
    subscriptionId: "",
    planId: companyPlans?.[planIndex]?.planId,
    planName: companyPlans?.[planIndex]?.name,
    status: companyPlans?.[planIndex]?.status?.toUpperCase() || "ACTIVE",
    billingCycle,
    startDate: startDate.toISOString(),
    expiryDate: expiryDate.toISOString(),
    autoRenew: false,
    paymentMethod: "PAYMENT_GETWAY",
    lastPaymentDate: startDate.toISOString(),
  };

  const payload = {
    companyClient: {
      clientId: "",
      founderAccount: true,
      status: "ACTIVE",
      subscription,
      businessProfile: {
        basicInfo: {
          businessName: registrationData?.businessName,
          legalName: "",
          description: registrationData?.description,

          industry: {
            industryId: registrationData?.industryId,
            category: registrationData?.business_Category,
            name: registrationData?.industryItem,
          },

          businessPhones: [
            registrationData?.businessPhoneNo1,
            registrationData?.businessPhoneNo2,
          ].filter(Boolean),

          businessEmail: registrationData?.email,

          website: "",

          foundedDate: null,

          businessType: "",

          status: "ACTIVE",
        },

        registration: {
          registrationNumber: "",
          registrationType: "",
          registrationCountry: "",
          registrationDate: null,
          taxIdentificationNumber: "", // TIN number
          vatRegistered: false,
          vatNumber: "",
          regulatoryStatus: "",
        },

        location: {
          headOffice: {
            country: registrationData?.nationality,
            state: registrationData?.state_of_address,
            city: "",
            address: "",
            postalCode: "",
            latitude: null,
            longitude: null,
          },
        },

        operationalProfile: {
          businessStage: "STARTUP",
          estimatedEmployees: null,
          estimatedBranches: 1,

          operatingHours: {
            open: "",
            close: "",
            timezone: "Africa/Lagos",
          },
        },

        branding: {
          logo: "",
          favicon: "",
          primaryColor: "",
          secondaryColor: "",
          coverImage: "",
        },
        contact: {
          whatsapp: "",
          facebook: "",
          instagram: "",
          linkedin: "",
        },
        businessRanking: {
          currentRank: "BRONZE",
          score: 0,
          nextRank: "SILVER",
          metrics: {
            employeeScore: 0,
            transactionScore: 0,
            revenueScore: 0,
            usageScore: 0,
            branchScore: 0,
          },
          progressPercentage: 0,
        },
      },
      statistics: {
        branches: 1,
        warehouses: 1,
        registers: 1,
        inventoryItems: 0,
        products: 0,
        productVariants: 0,
        staff: 1,
        customers: 0,
        suppliers: 0,
        sales: 0,
        purchases: 0,
      },
      founder: {
        founderId: "",
        userName: "",

        firstName: registrationData?.firstName,
        middleName: registrationData?.otherName,
        surname: registrationData?.surName,
        gender: registrationData?.gender,

        dateOfBirth: null,

        nationality: registrationData?.nationality,

        phone: registrationData?.phone,

        email: registrationData?.email,

        photo: "",

        address: {
          country: registrationData?.nationality,
          state: "",
          city: "",
          street: "",
          postalCode: "",
        },

        verification: {
          emailVerified: false,
          phoneVerified: false,
          kycLevel: "LEVEL_1",
          kycStatus: "PENDING",
        },
      },
      preferences: {
        language: "en",
        timezone: "Africa/Lagos",
        currency: "NGN",
        fiscalYearStart: "JANUARY",
        dateFormat: "DD/MM/YYYY",
        timeFormat: "24H",

        defaultBranchId: "",
        defaultWarehouseId: "",
        defaultInventoryId: "",

        receiptTemplate: "DEFAULT",
        invoiceTemplate: "DEFAULT",

        barcodeType: "CODE128",

        nightMode: false,
      },
      compliance: {
        kybStatus: "PENDING",
        riskLevel: "LOW",
        auditRequired: false,
        regulatoryBodies: [],
      },
      acquisition: {
        source: registrationData?.referralCode ? "STAFF_REFERRAL" : "ORGANIC",

        referral: {
          codeUsed: registrationData?.referralCode || null,

          // BACKEND WILL RESOLVE THESE
          referredBy: null,
          referredByStaffId: null,
          referredByRole: null,
          referredAt: null,
        },

        scope: {
          // BACKEND WILL RESOLVE THESE
          fdcId: null,
          sddId: null,
          edId: null,
          stateId: null,
          regionId: null,
        },
      },
      bank_accounts: [
        {
          accountId: "",
          accountName: "",
          accountNumber: "",
          bankName: "",
          bankCode: "",
          accountType: "CURRENT", // CURRENT | SAVINGS | DOMICILIARY
          currency: "NGN",
          swiftCode: "",
          iban: "",
          branchName: "",
          branchCode: "",
          sortCode: "",
          bvn: "",
          isPrimary: true,
          acceptPayments: false,
          verified: false,
          status: "ACTIVE",
        },
      ],
      storage: {
        usedMB: 0,
        limitMB: subscription.limits?.storageMB,
      },
      activity: {
        lastLogin: null,
        lastSeen: null,
        lastTransaction: null,
      },
      security: {
        twoFactorEnabled: false,
        loginAttempts: 0,
        accountLocked: false,
        lastPasswordChange: null,
      },
      financial: {
        defaultTaxRate: 0,
        taxInclusive: false,
        defaultDiscount: 0,
        fiscalCurrency: "NGN",
      },
      notifications: {
        email: true,
        sms: false,
        push: true,
        lowStock: true,
        subscriptionReminder: true,
      },
      auth: {
        credentials: {
          hashedPassword: registrationData?.password,
          passwordUpdatedAt: "",
          lastPasswordResetAt: null,
        },
        pointOfSale: {
          hashedPin: "000000",
          pinUpdatedAt: "",
          lastPinResetAt: "",
        },
        authentication: {
          method: "EMAIL_PHONE_AND_PASSWORD",
          status: "ACTIVE",
          lastLoginAt: "",
          failedLoginAttempts: 1,
          locked: false,
          lockReason: null,
        },
        tokens: {
          accessToken: "",
          refreshToken: "",
          expiresIn: 3600,
        },

        multiFactorAuth: {
          enabled: false,
          method: "TOTP",
          verifiedApps: ["Google Authenticator"],
          backupCodesGenerated: false,
        },

        oauthProviders: {
          google: null,
          facebook: null,
        },
      },
      permissions: ["*"],
      createdBy: "SYSTEM",
      lastModifiedBy: "",
      createdAt: new Date(),
    },
    companyDefaultBranch: {
      branchId: "",

      clientId: "",

      branchCode: "", // e.g. HQ, BR001

      branchName: "",

      description: "",

      branchType: "HEAD_OFFICE", // HEAD_OFFICE | BRANCH | OUTLET | FACTORY

      status: "ACTIVE", // ACTIVE | INACTIVE | CLOSED | SUSPENDED

      isHeadOffice: true,

      contact: {
        phoneNumbers: [],
        email: "",
        website: "",
      },

      address: {
        country: "",
        state: "",
        city: "",
        area: "",
        street: "",
        postalCode: "",
        landmark: "",

        coordinates: {
          latitude: null,
          longitude: null,
        },
      },

      manager: {
        staffId: "",
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
      },

      operatingHours: {
        timezone: "Africa/Lagos",

        monday: {
          open: "",
          close: "",
          closed: false,
        },

        tuesday: {
          open: "",
          close: "",
          closed: false,
        },

        wednesday: {
          open: "",
          close: "",
          closed: false,
        },

        thursday: {
          open: "",
          close: "",
          closed: false,
        },

        friday: {
          open: "",
          close: "",
          closed: false,
        },

        saturday: {
          open: "",
          close: "",
          closed: false,
        },

        sunday: {
          open: "",
          close: "",
          closed: true,
        },
      },

      settings: {
        currency: "NGN",
        timezone: "Africa/Lagos",
        receiptFooter: "",
        allowSales: true,
        allowPurchases: true,
        allowTransfers: true,
      },

      statistics: {
        warehouses: 0,
        registers: 0,
        staff: 0,
        products: 0,
        inventoryItems: 0,
        customers: 0,
        suppliers: 0,
        sales: 0,
        purchases: 0,
      },

      metadata: {
        source: "SYSTEM",
        imported: false,
        schemaVersion: 1,
      },

      createdBy: "",
      lastModifiedByBy: "",

      createdAt: new Date(),
    },
    companyDefaultInventory: {
      inventoryId: "",

      clientId: "",
      branchId: "",
      warehouseId: [""], // AN ITEM CAN EXIST IN SEVERAL BRANCHES SO THE BELOW IDs ARE FOR SCALABILITY

      inventoryCode: "",

      inventoryName: "Main Inventory",

      description:
        "Main inventory for managing, selling, and delivering company products and services.",

      inventoryType: "MAIN", // MAIN | RETAIL | WHOLESALE | SHOWROOM | PHARMACY | STORE

      status: "ACTIVE",

      isDefault: true,

      manager: {
        staffId: "",
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
      },

      contact: {
        phoneNumbers: [],
        email: "",
      },

      address: {
        country: "",
        state: "",
        city: "",
        area: "",
        street: "",
        postalCode: "",
        landmark: "",
      },

      settings: {
        allowSales: true,
        allowReturns: true,
        allowTransfers: true,

        barcodeScanning: true,
        qrScanning: true,

        negativeStock: false,
      },

      statistics: {
        items: 0,
        categories: 0,
        transactions: 0,
      },

      metadata: {
        source: "SYSTEM",
        imported: false,
        schemaVersion: 1,
      },
      banksAccount: [
        //       {
        //   id: "zenith-001",
        //   type: "bank",
        //   bankName: "Zenith Bank",
        //   accountName: "Abdullahi Musa",
        //   accountNumber: "1012345678",
        //   status: "default",
        //   shortName: "ZB",
        // },
      ],
      createdBy: "",
      lastModifiedBy: "",
      createdAt: new Date(),
    },
    companyDefaultWarehouse: {
      warehouseId: "",

      clientId: "",
      branchId: "",

      warehouseCode: "",

      warehouseName: "Main Warehouse",

      description:
        "Main warehouse used for receiving, storing, and dispatching inventory.",

      warehouseType: "MAIN", // MAIN | SECONDARY | DISTRIBUTION | RETURNS | COLD_STORAGE | TRANSIT

      status: "ACTIVE",

      isDefault: true,

      manager: {
        staffId: "",
        firstName: "",
        lastName: "",
        phone: "",
        email: "",
      },

      contact: {
        phoneNumbers: [],
        email: "",
      },

      address: {
        country: "",
        state: "",
        city: "",
        area: "",
        street: "",
        postalCode: "",
        landmark: "",

        coordinates: {
          latitude: null,
          longitude: null,
        },
      },

      capacity: {
        maximumItems: null,
        maximumWeight: null,
        weightUnit: "KG",
        storageArea: null,
        areaUnit: "m²",
      },

      settings: {
        allowReceiving: true,
        allowDispatch: true,
        allowTransfers: true,
        allowReturns: true,

        barcodeScanning: true,
        qrScanning: true,

        requireApprovalForTransfers: false,
      },

      statistics: {
        inventories: 1,
        items: 0,
        categories: 0,
        transactions: 0,
      },

      metadata: {
        source: "SYSTEM",
        imported: false,
        schemaVersion: 1,
      },

      createdBy: "",
      lastModifiedBy: "",

      createdAt: new Date(),
    },
  };

  const $checkExistance = async () => {
    setLoading(true);
    await axios
      .get(
        `${serverHost}/new_client/register/checkExist/${registrationData.email}`,
      )
      .then((response) => {
        newClient = response.data.newClient;
        if (response.data.status === 201) {
          handleSubmission();
        } else if (response.data.status === 408) {
          setDoesExist(true);
          // This is a fallback for an Existing Email address that is already in use
          enqueueSnackbar(`${response.data.message}`, {
            variant: "error",
            autoHideDuration: 3000,
          });
          setLoading(false);
        }
      })
      .catch((err) => {
        if (err.code === "ERR_NETWORK") {
          enqueueSnackbar(
            `${err.message} : please connect to the internet and try again`,
            {
              variant: "error",
              autoHideDuration: 3000,
            },
          );
        } else {
          enqueueSnackbar(`${err.message}`, {
            variant: "error",
            autoHideDuration: 3000,
            style: {
              fontSize: "18px",
              fontWeight: "bold",
            },
          });
        }

        console.log(err?.code || "REQUEST_FAILED");

        setLoading(false);
      });
  };
  const apiPostNewClient = async () => {
    try {
      setLoading(true);

      const { data } = await axios.post(
        `${serverHost}/new_client/register`,
        payload,
        {
          timeout: 30000, // 30 seconds
        },
      );

      newClient = data.newClient;

      switch (data.status) {
        case 201:
          enqueueSnackbar(data.message, {
            variant: "success",
            autoHideDuration: 3000,
          });

          navigateTo("/company-registration/registered-success?page=1");
          break;

        case 408:
        case 409:
        case 400:
        case 401:
        case 403:
        case 404:
        case 422:
        case 500:
          enqueueSnackbar(data.message, {
            variant: "error",
            autoHideDuration: 4000,
          });
          break;

        default:
          enqueueSnackbar(data.message || "Something went wrong.", {
            variant: "warning",
            autoHideDuration: 4000,
          });
      }
    } catch (err) {
      let message = "Something went wrong. Please try again.";

      if (err.code === "ERR_NETWORK") {
        message =
          "No internet connection. Please check your network and try again.";
      } else if (err.code === "ECONNABORTED") {
        message = "Request timed out. Please try again.";
      } else if (err.response) {
        message =
          err.response.data?.message ||
          `Server responded with status ${err.response.status}.`;
      } else if (err.request) {
        message = "Server is currently unavailable. Please try again later.";
      } else {
        message = err.message;
      }

      enqueueSnackbar(message, {
        variant: "error",
        autoHideDuration: 4000,
        style: {
          fontSize: "16px",
          fontWeight: 600,
        },
      });

      console.error("Registration Error:", err?.code || "REQUEST_FAILED");
    } finally {
      setLoading(false);
    }
  };
  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validationSchema = Yup.object().shape({
    firstName: Yup.string().required("First name is required"),
    surName: Yup.string().required("Surname is required"),
    // otherName: Yup.string().required("Other name is required"),
    gender: Yup.string().required("Gender is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    password: Yup.string().required("password is required"),
    phone: Yup.string().required("Phone number is required"),
    termsOfService: Yup.boolean()
      .oneOf([true], "Please accept the Terms of Service")
      .required("Please accept the Terms of Service"),
  });

  const validateForm = async () => {
    try {
      await validationSchema.validate(registrationData, {
        abortEarly: false,
      });
      setErrors({});
      return true; // Form is valid
    } catch (validationErrors) {
      const formattedErrors = {};
      validationErrors.inner.forEach((error) => {
        formattedErrors[error.path] = error.message;
      });
      setErrors(formattedErrors);
      return false; // Form is invalid
    }
  };

  const executeValidation = async () => {
    const isValid = await validateForm();

    if (isValid) {
      setIsSubmitting(true);
      $checkExistance();
    } else if (errors.termsOfService) {
      setAlert({
        message: "Please accept the Terms of Service",
        type: "warning",
      });
    }
  };

  // change plan safely
  const changePlan = (newPlan, index) => {
    setSearchParams({ plan: newPlan, index: index });
  };

  // FUNCTIONS TO RECOGNIZE THE DEVICES COUNTRY LOCATIONS
  async function getUserCountry() {
    const res = await fetch("https://ipapi.co/json/");
    const data = await res.json();

    return {
      country: data.country_name,
      countryCode: data.country_code,
    };
  }

  /// PAYMENT GATEWAY INTEGRATION

  function accountFee() {
    const pricing = companyPlans?.[planIndex]?.pricing;

    return pricing
      ? Number(
          billingCycle === "YEARLY"
            ? pricing.yearly?.$numberDecimal
            : pricing.monthly?.$numberDecimal,
        )
      : 0;
  }
  const config = {
    // public_key: `${process.env.REACT_APP_TEST_PAYMENT_KEY}`,
    public_key: "FLWPUBK-c471ed8a7c4f5cd4691bb6023e513fba-X",
    tx_ref: `order-${Date.now()}`,
    amount: `${accountFee()}`,
    currency: "NGN",
    // redirect_url: "http://localhost:3000/create_new_account/queries?page=1",
    payment_options: "card,mobilemoney,ussd",
    customer: {
      email: registrationData.email,
      phone_number: registrationData.phone,
      name: registrationData.firstName,
    },
    customizations: {
      title: "Universe Inventory",
      description: "Payment for Universe Inventory Subscription",
      logo: "https://st2.depositphotos.com/4403291/7418/v/450/depositphotos_74189661-stock-illustration-online-shop-log.jpg",
    },
  };

  const handleFlutterPayment = useFlutterwave(config);

  // ❌ REMOVED WRONG AUTO CALL (THIS WAS THE BUG)

  /* handleFlutterPayment({
  callback: async (response) => {
    if (
      response.status === "successful" ||
      response.status === "completed"
    ) {
      await activateSubscription(response);
    }

    closePaymentModal();
  },

  onClose: () => {
    console.log("Payment modal closed");
  },
}); */

  // END OF PAYMENT GATEWAY INTEGRATION

  function handleSubmission() {
    handleFlutterPayment({
      callback: async (response) => {
        if (
          response.status === "successful" ||
          response.status === "completed"
        ) {
          await apiPostNewClient();
        }

        closePaymentModal();
      },

      onClose: () => {
        console.log("");
      },
    });
    setLoading(false);
  }
  async function apiGetCompanyData() {
    try {
      setLoading(true);
      const [plans, features, permissions, roles] = await Promise.all([
        axios.get(
          `${serverHost}/company_features/get_plans`,
        ),
        axios.get(
          `${serverHost}/company_features/get_features`,
        ),
        axios.get(
          `${serverHost}/company_features/get_permissions`,
        ),
        axios.get(
          `${serverHost}/company_features/get_roles`,
        ),
      ]);

      companyPlans = plans?.data?.companyPlans;
      companyFeatures = features?.data?.companyFeatures;
      companyPermissions = permissions?.data?.companyPermissions;
      companyRoles = roles?.data?.companyRoles;

      console.log(
        companyPlans,
        companyFeatures,
        companyPermissions,
        companyRoles,
      );
    } catch (error) {
      console.error(
        "Failed to fetch company data:",
        error?.code || "REQUEST_FAILED",
      );
      throw error; // Re-throw so calling functions know it failed
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    apiGetCompanyData();
    const meta = document.querySelector('meta[name="theme-color"]');

    if (meta) {
      meta.setAttribute("content", "#6d4aff");
    }

    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        // clicked outside
        setOpencountryCodes(false);
        setOpenGender(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };

    async function init() {
      const user = await getUserCountry();

      const match = countriesOnEarth.find((c) => c.country === user.country);

      if (match) {
        setRegistrationData({
          nationality: match.country,
          international_dialing_code: match.code,
          imojies: match.flag,
        });
      }
    }

    init();
  }, []);

  return (
    <>
      {loading ? <IsLoading /> : null}
      {errors.termsOfService && <AlertBar alert={alert} setAlert={setAlert} />}
      <section className="fx-jc" id="regCont">
        <div className="regMainCont fx-cl space2">
          <div className="regHeader fx-cl fx-ac space2">
            <h3>High-speed, Secure & Stress-Free to your Business</h3>
            <div className="regHTag mobileRWDhide fx-ac">
              <figure className="fx-ac space2">
                <span>
                  <DashboardRoundedIcon fontSize="large" />
                </span>
                <span>Real time sales</span>
              </figure>
              <figure className="fx-ac space2">
                <span>
                  <AssignmentRoundedIcon fontSize="large" />
                </span>
                <span>No-logs policy</span>
              </figure>
              <figure className="fx-ac space2">
                <span>
                  <PeopleAltRoundedIcon fontSize="large" />
                </span>
                <span>Protected by Universe Inventory Laws</span>
              </figure>
              <figure className="fx-ac space2">
                <span>
                  <CategoryRoundedIcon fontSize="large" />
                </span>
                <span>Endless possiblities</span>
              </figure>
            </div>
            <figure className="regTag mobileRWDhide">
              <CategoryRoundedIcon fontSize="small" /> <strong>100%</strong>{" "}
              Fast & Effortless <strong>Inventory</strong> for all Business
            </figure>
          </div>
          <div className="regMainDiv fx-cl space3">
            <div className="mobileRWDhide fx-ac fx-jb space4">
              <div className=" regStep fx-ac space2">
                <figure>Step 1</figure> <h3>Select your plan</h3>
              </div>
            </div>

            <div className="fx-ac fx-jc">
              <div className="regPricingBtnPln regDuration fx-ac fx-jc space3">
                <button
                  className={billingCycle === "MONTHLY" ? "active" : ""}
                  onClick={() => setBillingCycle("MONTHLY")}
                >
                  Monthly
                </button>
                <button
                  className={billingCycle === "YEARLY" ? "active" : ""}
                  onClick={() => setBillingCycle("YEARLY")}
                >
                  Annually <span className="pricingDiscount">-20%</span>
                </button>
              </div>
            </div>
            <div className="regPricing fx-as space2">
              {companyPlans?.map((item, index) => (
                <figure
                  key={item._id}
                  onClick={() => changePlan(item.slug, index)}
                  className={`regPricingCard ${
                    item.slug.length > 0 && `${item.slug}`
                  }
                     ${plan === item.slug ? "active" : ""} ${
                       item.tag ? item.tag : ""
                     }`}
                >
                  {item.tag && <span className="bestValueTag">{item.tag}</span>}

                  <div className="cardPrcConts fx-cl space1">
                    <div className="fx-ac spacem">
                      <span className="regPlanRadius">&nbsp;</span>
                      <h5>{item.name}</h5>
                    </div>

                    <div className="fx-cl spacem">
                      <div className="fx-cl">
                        {" "}
                        <span className="regFormBilled">
                          {billingCycle === "YEARLY"
                            ? "Billed annually"
                            : "Billed monthly"}
                        </span>
                        {/* Current billing price */}
                        <p className="regPrice">
                          ₦
                          {billingCycle === "YEARLY"
                            ? Number(
                                item.pricing.yearly.$numberDecimal,
                              ).toLocaleString()
                            : Number(
                                item.pricing.monthly.$numberDecimal,
                              ).toLocaleString()}
                          <span
                            className="mobileRWDhide"
                            style={{ fontSize: "1rem" }}
                          >
                            /{billingCycle === "YEARLY" ? "Year" : "Month"}
                          </span>
                        </p>
                      </div>
                      {/* Optional original price */}
                      {billingCycle === "YEARLY" ? (
                        <span className="regformActualPrice">
                          ₦
                          {(
                            Number(item.pricing.actualPrice.$numberDecimal) * 12
                          ).toLocaleString()}
                        </span>
                      ) : (
                        <span className="regformActualPrice">
                          ₦
                          {Number(
                            item.pricing.actualPrice.$numberDecimal,
                          ).toLocaleString()}
                        </span>
                      )}

                      <p className="discountReg fw500 fx-ac space1">
                        <span className="fw600">
                          {billingCycle === "YEARLY"
                            ? `Monthly ₦${(
                                Number(item.pricing.yearly.$numberDecimal) / 12
                              ).toLocaleString()}`
                            : `Save ${(
                                Number(item.pricing.monthly.$numberDecimal) *
                                  12 -
                                Number(item.pricing.yearly.$numberDecimal)
                              ).toLocaleString()} with yearly billing`}
                        </span>

                        <strong
                          style={{
                            color: "#5AC2AE",
                            backgroundColor: "#EBFFFA",
                            padding: ".3rem",
                            borderRadius: ".4rem",
                          }}
                        >
                          {Number(item.pricing.discountPercent.$numberDecimal)}%
                          OFF
                        </strong>
                      </p>
                    </div>

                    {/* {plan === item.slug && (
                      <button
                        onClick={() => {
                          document
                            .getElementById("regFormData")
                            ?.scrollIntoView({
                              behavior: "smooth",
                            });
                        }}
                        className="planBtnProceed mobileRWDhide"
                      >
                        Continue
                      </button>
                    )} */}
                  </div>
                </figure>
              ))}
            </div>
          </div>

          <div
            id="regFormData"
            className="personalInfoCont regMainDiv regFormData fx-cl"
            style={{ zIndex: "1" }}
          >
            <div className="fx-cl space3">
              <div className=" regStep fx-ac space2">
                <figure>Step 2</figure> <h3>Personal Information</h3>
              </div>

              <div className="fx-cl space2 ">
                <div className="fx-ac space2 regFormfloat">
                  <div className="fx-cl spacem">
                    <label htmlFor="text">First name:</label>
                    <div
                      className="fx-ac space1 regInputCont"
                      style={{
                        border: `${errors.firstName && "3px solid #e16969"}`,
                      }}
                    >
                      <input
                        value={registrationData.firstName}
                        onChange={(event) =>
                          setRegistrationData({
                            firstName: event.target.value,
                          })
                        }
                        type="text"
                        name="first_name"
                      />
                    </div>
                  </div>
                  <div className="fx-cl  spacem">
                    <label htmlFor="text">Sur name:</label>
                    <div
                      className="fx-cl space1 regInputCont"
                      style={{
                        border: `${errors.surName && "3px solid #e16969"}`,
                      }}
                    >
                      <input
                        value={registrationData.surName}
                        onChange={(event) =>
                          setRegistrationData({ surName: event.target.value })
                        }
                        type="text"
                        name="sur_name"
                      />
                    </div>
                  </div>
                </div>
                <div className="fx-ac space2 regFormfloat">
                  <div className="fx-cl spacem">
                    <label htmlFor="text">Other name:</label>
                    <div className="fx-ac space1 regInputCont">
                      <input
                        value={registrationData.otherName}
                        onChange={(event) =>
                          setRegistrationData({ otherName: event.target.value })
                        }
                        type="text"
                        name="other_name"
                      />
                    </div>
                  </div>
                  <div className="fx-cl spacem">
                    <label htmlFor="text">Gender:</label>
                    <div
                      className="fx-ac space1 regInputCont fx-ac"
                      style={{
                        border: `${errors.gender && "3px solid #e16969"}`,
                        overflow: "unset",
                      }}
                    >
                      <div className="registrantions-page-limit">
                        <button
                          className="genderBtn fx-ac spacem"
                          onClick={() => setOpenGender(!openGender)}
                        >
                          {registrationData.gender === "male" && (
                            <Person2Icon style={{ fontSize: "1.8rem" }} />
                          )}
                          {registrationData.gender === "female" && (
                            <Face4Icon style={{ fontSize: "1.8rem" }} />
                          )}
                          {!registrationData?.gender
                            ? "Select gender ▾"
                            : registrationData?.gender}
                        </button>

                        {openGender && (
                          <ul
                            ref={wrapperRef}
                            className="registrantions-limit-dropdown"
                          >
                            <li
                              key="01-male"
                              onClick={() => {
                                setRegistrationData({
                                  gender: "male",
                                });
                                setOpenGender(false);
                              }}
                              className="registrantions-limit-item fx-ac spacem"
                            >
                              <Person2Icon style={{ fontSize: "2.8rem" }} />
                              <span>Male</span>
                            </li>

                            <li
                              key="02-female"
                              onClick={() => {
                                setRegistrationData({
                                  gender: "female",
                                });
                                setOpenGender(false);
                              }}
                              className="registrantions-limit-item fx-ac spacem"
                            >
                              <Face4Icon style={{ fontSize: "2.8rem" }} />
                              <span>Female</span>
                            </li>
                          </ul>
                        )}
                      </div>
                      {/* {errors.gender && (
                <div style={{ color: "red" }}>{errors.gender}</div>
              )} */}
                    </div>
                  </div>
                </div>
                <div className="fx-ac space2 regFormfloat">
                  <div className="fx-cl spacem">
                    <label htmlFor="text">Email:</label>
                    <div
                      className={`fx-ac space1 regInputCont ${doesExist == true && "emailExist"}`}
                      style={{
                        border: `${errors.email && "3px solid #e16969"}`,
                      }}
                    >
                      <input
                        value={registrationData.email}
                        onChange={(event) =>
                          setRegistrationData({ email: event.target.value })
                        }
                        type="email"
                        name="email"
                      />
                      {/* {errors.email && <div style={{ color: "red" }}>{errors.email}</div>} */}
                    </div>
                  </div>
                  <div className="fx-cl spacem">
                    <label htmlFor="text">Phone number:</label>
                    <div
                      className="fx-ac space1 regInputCont"
                      style={{
                        border: `${errors.phone && "3px solid #e16969"}`,
                        overflow: "unset",
                      }}
                    >
                      <div
                        className="registrantions-page-limit"
                        style={{ width: "auto" }}
                      >
                        <button
                          className="registrantions-page-limit-btn fx-ac spacem"
                          onClick={() => setOpencountryCodes(!opencountryCodes)}
                        >
                          <img src={registrationData?.flag} alt="flag" />
                          {registrationData?.international_dialing_code}
                          <span className="registrantions-page-limit-arrow">
                            ▾
                          </span>
                        </button>

                        {opencountryCodes && (
                          <ul
                            ref={wrapperRef}
                            className="registrantions-limit-dropdown"
                          >
                            <li>
                              <input
                                id="searchcountryCode"
                                type="text"
                                placeholder="Search country..."
                                value={searchTermCountries}
                                onChange={handleSearchCountries}
                              />
                            </li>

                            {filteredCountries.length > 0
                              ? filteredCountries.map((item, index) => (
                                  <li
                                    key={index}
                                    onClick={() => {
                                      setRegistrationData({
                                        nationality: item.country,
                                        international_dialing_code: item.code,
                                        flag: item.flag,
                                      });
                                      setFilteredCountries("");
                                      setSearchTermCountries("");
                                      setOpencountryCodes(false);
                                    }}
                                    className="registrantions-limit-item"
                                  >
                                    <img src={item.flag} alt="flag" />
                                    <span className="fx-ac space2">
                                      {item.code}
                                      {item.country}
                                    </span>
                                  </li>
                                ))
                              : countriesOnEarth.map((item, index) => (
                                  <li
                                    key={index}
                                    className="registrantions-limit-item fx-ac spacem"
                                    onClick={() => {
                                      setRegistrationData({
                                        nationality: item.country,
                                        international_dialing_code: item.code,
                                        flag: item.flag,
                                      });

                                      setOpencountryCodes(false);
                                    }}
                                  >
                                    <img src={item.flag} alt="flag" />
                                    <span className="fx-ac space2">
                                      {item.code}
                                      {item.country}
                                    </span>
                                  </li>
                                ))}
                          </ul>
                        )}
                      </div>

                      <input
                        value={registrationData.phone}
                        onChange={(event) =>
                          setRegistrationData({
                            phone: event.target.value,
                          })
                        }
                        style={{ borderRadius: "1.2rem" }}
                        type="number"
                        name="phoneNumber"
                      />
                      {/* {errors.phone && (
              <p className="error">{errors.phone}</p>
            )} */}
                    </div>
                  </div>
                </div>

                <div className="fx-ac space2">
                  <div className="fx-cl fg1 spacem">
                    <label htmlFor="text">Password:</label>
                    <div
                      className="fx-ac space1 regInputCont"
                      style={{
                        border: `${errors.password && "3px solid #e16969"}`,
                      }}
                    >
                      <input
                        value={registrationData.password}
                        onChange={(event) =>
                          setRegistrationData({ password: event.target.value })
                        }
                        type="password"
                        name="password"
                      />
                      {/* {errors.password && <div style={{ color: "red" }}>{errors.password}</div>} */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="redirectCont fx-cl spacem">
                <p>
                  <strong>
                    Already have an account?{" "}
                    <Link to="/access/client-portal/authentication/sign-in">
                      Sign in
                    </Link>
                  </strong>
                </p>
                <p>
                  Your information is safe with us. We'll only contact when it's
                  required to provide our services.
                </p>
              </div>
            </div>

            <div className="mobileRWDhide fx-cl space1">
              <div className=" regStep fx-cl ">
                <div className="fx-ac fx-jb space1">
                  <figure>
                    {billingCycle === "MONTHLY"
                      ? "Billed Monthly"
                      : "Billed Yearly"}
                  </figure>
                  <span>&nbsp;</span>
                </div>
                <h3 style={{ textTransform: "capitalize" }}>{plan}</h3>
              </div>
              {/* <div className="pricing-card">
                Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                Dolore, dolor corrupti!
              </div> */}
              <div className="fx-cl space6 fg1 fx-jb">
                <div className="fx-cl spacem">
                  <ul>
                    {plans[planIndex].features.map((f, i) => (
                      <li key={i} className="fx-ac spacem">
                        <figure className="featuresIcon">{f.logo}</figure>
                        <span className="featuresDisc">{f.discription}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <p className="prcFooter">{plans[planIndex].footer}</p>
              </div>
            </div>
          </div>
          <div className="regMainDiv  fx-cl space3">
            <div className=" regStep fx-ac space2">
              <figure>Step 3</figure> <h3>Business Profile</h3>
            </div>
            <div className="step3Frm g g3 space2 fs3">
              <div className="fx-cl spacem">
                <label htmlFor="text">Business Category</label>
                <div className="fx-ac space1 regInputCont ">
                  <select
                    name="business_Category"
                    value={registrationData.business_Category}
                    onChange={(event) => {
                      const selectedIndustry = industriesCategoriesData.find(
                        (industry) => industry.section === event.target.value,
                      );

                      setRegistrationData({
                        business_Category: event.target.value,
                        industryId: selectedIndustry?.industryId || "",
                      });
                    }}
                  >
                    <option value="" hidden>
                      Select Business Category
                    </option>

                    {industriesCategoriesData.map((section) => (
                      <option key={section.section} value={section.section}>
                        {section.section}
                      </option>
                    ))}
                  </select>{" "}
                </div>
              </div>

              <div className="fx-cl spacem">
                <label htmlFor="text">Industry</label>

                <div className="fx-ac space1 regInputCont ">
                  <select
                    value={registrationData.industryItem}
                    onChange={(event) =>
                      setRegistrationData({
                        industryItem: event.target.value,
                      })
                    }
                  >
                    <option value="" hidden>
                      Select Industry
                    </option>

                    {industriesCategoriesData
                      .find(
                        (section) =>
                          section.section ===
                          registrationData.business_Category,
                      )
                      ?.items.map((item) => (
                        <option key={item.title} value={item.title}>
                          {item.title}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="fx-cl spacem">
                <label htmlFor="text">Business Name:</label>
                <div
                  className="fx-ac space1 regInputCont"
                  style={{
                    border: `${errors.businessName && "3px solid #e16969"}`,
                  }}
                >
                  <input
                    value={registrationData.businessName}
                    onChange={(event) =>
                      setRegistrationData({
                        businessName: event.target.value,
                      })
                    }
                    type="text"
                    name="businessName"
                  />
                </div>
              </div>
              <div className="fx-cl spacem">
                <label htmlFor="text">Description:</label>
                <div className="fx-ac space1 regInputCont">
                  <textarea
                    value={registrationData.description}
                    onChange={(event) =>
                      setRegistrationData({
                        description: event.target.value,
                      })
                    }
                    name="description"
                  />
                </div>
              </div>
              <div className="fx-cl spacem">
                <label htmlFor="text">Business Tel+:</label>
                <div className="fx-ac space1 regInputCont">
                  <input
                    value={registrationData.businessPhoneNo1}
                    onChange={(event) =>
                      setRegistrationData({
                        businessPhoneNo1: event.target.value,
                      })
                    }
                    type="number"
                    name=" businessPhoneNo1"
                  />
                </div>
              </div>
              <div className="fx-cl spacem">
                <label htmlFor="text">Second Business Tel+:</label>
                <div className="fx-ac space1 regInputCont">
                  <input
                    value={registrationData.businessPhoneNo2}
                    onChange={(event) =>
                      setRegistrationData({
                        businessPhoneNo2: event.target.value,
                      })
                    }
                    type="number"
                    name="businessPhoneNo2"
                  />
                </div>
              </div>
              <div className="fx-cl spacem">
                <label htmlFor="referralCode">
                  Referral Code <span>(Optional)</span>
                </label>

                <div className="fx-ac space1 regInputCont">
                  <input
                    id="referralCode"
                    type="text"
                    name="referralCode"
                    placeholder="Enter referral code"
                    value={registrationData.referralCode}
                    onChange={(event) =>
                      setRegistrationData({
                        referralCode: event.target.value.toUpperCase().trim(),
                      })
                    }
                  />
                </div>
              </div>
            </div>
            <div className="regFormData mobileRWDhide termsOfService fx-cl space3">
              <div className="termsDescr fx-ac space2  fs2">
                <input
                  type="checkbox"
                  name="terms_of_service"
                  style={{
                    transform: "scale(1.5)",

                    border: `${errors.termsOfService && "3px solid #e16969"}`,
                  }}
                  checked={registrationData.termsOfService}
                  onChange={(e) =>
                    setRegistrationData({
                      termsOfService: e.target.checked,
                    })
                  }
                />
                <p style={{ lineHeight: "1.5" }}>
                  By submitting this form,
                  <strong>
                    you acknowledge and agree to the
                    <Link to="/access/client-portal/authentication/sign-in">
                      {" "}
                      Terms of Service{" "}
                    </Link>{" "}
                    and
                    <Link to="/access/client-portal/authentication/sign-in">
                      {" "}
                      Privacy Policy{" "}
                    </Link>{" "}
                  </strong>{" "}
                  of the Universe Inventory Management Platform.
                </p>
              </div>
              <button
                className="regbtnSubmit"
                // onClick={() => executeValidation()}

                onClick={() => executeValidation()}
                // disabled={isSubmitting}
              >
                Submit application
              </button>
            </div>
          </div>
          <div className="computerRWDhide">
            <div className="regFormData   fx-cl space3">
              <div className="termsDescr fx-ac space2  fs2">
                <input
                  type="checkbox"
                  name="terms_of_service"
                  style={{
                    transform: "scale(1.5)",
                    boxShadow: `${
                      errors.termsOfService && "inset 0rem 0rem 0rem 0.1rem red"
                    }`,
                  }}
                  checked={registrationData.termsOfService}
                  onChange={(e) =>
                    setRegistrationData({
                      termsOfService: e.target.checked,
                    })
                  }
                />
                <p style={{ lineHeight: "1.5" }}>
                  By submitting this form,
                  <strong>
                    you acknowledge and agree to the
                    <Link to="/access/client-portal/authentication/sign-in">
                      {" "}
                      Terms of Service{" "}
                    </Link>{" "}
                    and
                    <Link to="/access/client-portal/authentication/sign-in">
                      {" "}
                      Privacy Policy{" "}
                    </Link>{" "}
                  </strong>{" "}
                  of the Universe Inventory Management Platform.
                </p>
              </div>
              <button
                className="regbtnSubmit"
                onClick={() => executeValidation()}

                // onClick={() => apiPostNewClient()}
                // disabled={isSubmitting}
              >
                Submit application
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
